import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_ORIGIN = "https://vishnujimaharaj.com";

export const kathaBookUrl = (book) => `/katha/${book.slug}/`;
export const kathaStoryUrl = (book, story) => `${kathaBookUrl(book)}${story.slug}/`;

/** Each SPA navigation updates title, description, canonical, social cards and JSON-LD. */
export default function KathaSeo({ title, description, path, image, type = "website", schema = [], noindex = false }) {
  const url = `${SITE_ORIGIN}${path}`;
  const imageUrl = `${SITE_ORIGIN}${image || "/logo.png"}`;
  const schemas = Array.isArray(schema) ? schema : [schema];
  return (
    <Helmet prioritizeSeoTags>
      <html lang="hi" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content="Vishnu Ji Maharaj" />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="hi_IN" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {schemas.filter(Boolean).map((item, index) => (
        <script key={`${path}-schema-${index}`} type="application/ld+json">
          {JSON.stringify({ "@context": "https://schema.org", ...item }).replace(/</g, "\\u003c")}
        </script>
      ))}
    </Helmet>
  );
}

export function breadcrumbSchema(crumbs) {
  return {
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, index) => ({
      "@type": "ListItem", position: index + 1, name: crumb.name,
      item: `${SITE_ORIGIN}${crumb.path}`
    }))
  };
}
